<template>
  <b-row class="justify-content-center no-gutters" :class="step">
    <b-col sm="12" md="9" lg="7" xl="6">
      <div
        <response :items="errors"></response>

        <b-alert variant="success" v-if="success" show>
          {{ $t('deleted.title') }}
        </b-alert>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data () {
    return {
      success: false,
      errors: []
    }
  },
  methods: {
    ...mapActions({
      completeDeleteSelf: 'auth/completeDeleteSelf'
    })
  },
  mounted () {
    const code = this.$route.params.code
    if (code) {
      this.completeDeleteSelf({
        payload: code,
        context: this
      })
    } else {
      this.$router.push({name: `Home.${this.$i18n.i18next.language}`})
    }
  }
}
</script>

<style lang="scss" scoped>
  .lang-switcher {
    position: absolute;
    top: 0;
    right: 0;
    padding: 0.5rem;
  }
</style>
